import Vue from 'vue';
import VueRouter from 'vue-router'
import store from './store'

import App from './App.vue';
import HomeVue from './components/Home.vue';
import WorkshopsCycle2Vue from './components/WorkshopsCycle2.vue';
import WorkshopsCycle3Vue from './components/WorkshopsCycle3.vue';
import ModulesCollegeVue from './components/ModulesCollege.vue';
import ManagementVue from './components/Management.vue';
import LoginVue from './components/Login.vue';
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'


Vue.config.productionTip = true;
Vue.use(VueRouter)
Vue.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha)


const router = new VueRouter({
    base: __dirname,
    routes: [
        {
			name: 'home',
            path: '/',
            component: HomeVue,
            beforeEnter: (to, from, next) => {
                if (store.state.config.websiteProtection === true && store.state.authenticated === false) {
					next({ name: 'login' })
                }
                else {
                    next();
                }
            }
        },
        {   
			name: 'login',
            path: '/login',
            component: LoginVue,
        },
        {
            path: '/workshops_cycle_2',
            component: WorkshopsCycle2Vue,
            beforeEnter: (to, from, next) => {
                if (store.state.config.websiteProtection === true && store.state.authenticated === false) {
					next({ name: 'login' })
                }
                else {
                    next();
                }
            }
        },
        {
            path: '/workshops_cycle_3',
            component: WorkshopsCycle3Vue,
            beforeEnter: (to, from, next) => {
                if (store.state.config.websiteProtection === true && store.state.authenticated === false) {
					next({ name: 'login' })
                }
                else {
                    next();
                }
            }
        },
        {
            path: '/modules_college',
            component: ModulesCollegeVue,
            beforeEnter: (to, from, next) => {
                if (store.state.config.websiteProtection === true && store.state.authenticated === false) {
					next({ name: 'login' })
                }
                else {
                    next();
                }
            }
        },
        {
			name: 'management',
            path: '/management',
            component: ManagementVue,
            meta: { requiresAuth: true },
        },
    ]
})


/* *** Auto-redirect if a route requires authentification and not logged-in *** */
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth === true && !store.state.authenticated) {
        next({ name: 'login' })
    } else {
        next()
    }
})


/* ******** Load config file dynamically ********************** */
fetch('config.json?version=${Date.now()}')
.then((res) => { return res.json() })
.then((configJSON) => {
    const env = (process.env.NODE_ENV === undefined) ? '' : process.env.NODE_ENV
    const config = { ...configJSON.default, ...configJSON[env] }
    // In store
    store.state.config = config
    console.log("store.state " + JSON.stringify(store.state))

    Vue.prototype.$config = config
    //this.$config.KEY

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');    
})

